export const confKinds = ['conf_external', 'conf_inner'];
